import React from 'react';
import PropTypes from 'prop-types';
import { Container } from 'reactstrap';

import ListContainer from './ListContainer';

import './PaxesManager.css';

const PaxesManager = (props) => {
  const {
    reservationId,
    roomsList,
    readOnly,
    hasToValidate
  } = props;

  const handlePaxData = (roomId, paxData) => {
    props.handleRoomPaxData(reservationId, roomId, paxData)
  };

  const handleNumberOfPaxes = (roomId, desiredNumber) => {
    props.handleRoomPaxList(reservationId, roomId, desiredNumber);
  };

  return (
    <Container>
      {
        roomsList.map((room) => {
          const { id, paxes, distribution } = room;

          if (!paxes || paxes.length === 0) return <React.Fragment key={id} />

          return (
            <ListContainer
              key={id}
              roomId={id}
              paxes={paxes}
              distribution={distribution}
              readOnly={readOnly}
              hasToValidate={hasToValidate}
              handlePaxesData={handlePaxData}
              handleNumberOfPaxes={handleNumberOfPaxes}
            />
          )
        })
      }
    </Container>
  );
};

PaxesManager.propTypes = {
  reservationId: PropTypes.number.isRequired,
  roomsList: PropTypes.arrayOf(PropTypes.object),
  readOnly: PropTypes.bool,
  hasToValidate: PropTypes.bool,
  handleRoomPaxData: PropTypes.func,
  handleRoomPaxList: PropTypes.func
};

PaxesManager.defaultProps = {
  roomsList: [],
  readOnly: false,
  hasToValidate: false,
  handleRoomPaxData: () => {},
  handleRoomPaxList: () => {}
};

export default React.memo(PaxesManager);
